export enum CustomersColumns {
	id = "Id",
	type = "Type",
	org = "Org",
	status = "Status",
	name = "Name",
	createdAt = "Created At",
}

export type AllowedCustomersColumns =
	| CustomersColumns.id
	| CustomersColumns.type
	| CustomersColumns.org
	| CustomersColumns.status
	| CustomersColumns.name
	| CustomersColumns.createdAt
